import React from 'react';
import './MenuSection.css';

const MenuSection = () => {
  return (
    <section className="menu-section">
      <div className="container">
        <h2 className="section-title">Our Special Service</h2>
        <div className="menu-image-container">
          <img 
            src={require('./assets/celebrity cuts menu card .pdf (2).png')} 
            alt="Celebrity Cuts Menu" 
            className="menu-image"
          />
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
